// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"27d7b69e","61":"522ebbfc","154":"f1383c60","250":"7fe9ded6","273":"3a00d35d","279":"ddd9455e","470":"6d65655b","510":"90ffbbc7"}[chunkId] + ".chunk.js";
};